<template>
  <div v-if="this.props != null" class="MenuSub">
    <div class="Menu-Arrow"></div>
    <div class="Menu-Links" v-for="(data, index) in this.datas[this.props]" :key="index">
      <ul v-if="index == 'links'">
        <li v-for="(link, index) in data" :key="index">
          <router-link :to="link.route" @click.native="close(); $scrollToTop();">
            {{ link.name }}
          </router-link>
          <div class="MenuSub--divider"></div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MenuSub",
  props: ['props'],
  data() {
    return {
      datas: [
        {
          id: 0,
          links: [
            {name: 'Recrutement et intégration des salariés', route: '/conseil/recrutement'},
            {name: 'Accompagnement de l\'entreprise et des salariés', route: '/conseil/accompagnement'},
            {name: 'Externalisation des Entretiens Professionnels', route: '/conseil/externalisation'},
          ]
        },
        {
          id: 1,
          links: [
            {name: 'Accompagnement vers et dans l\'emploi', route: '/evolution/accompagnement'},
            {name: 'Bilan de compétences', route: '/evolution/bilan'},
            {name: 'Validation des Acquis de l\'Expérience (VAE)', route: '/evolution/validation'},
          ]
        },
        {
          id: 2,
          links: [
            {name: 'JobStream', route: '/nous-connaitre/jobstream'},
            {name: 'L\'équipe', route: '/nous-connaitre/equipe'},
            {name: 'Nous rejoindre', route: '/nous-connaitre/nous-rejoindre'},
            {name: 'Notre engagement qualité', route: '/nous-connaitre/engagement-qualite'},
            {name: 'Ils nous font confiance', route: '/nous-connaitre/confiance'},
            {name: 'Nos partenaires', route: '/nous-connaitre/partenaires'},
          ]
        }
      ]
    }
  },
  methods: {
    close() {
      this.$parent.componentKey = null;
    }
  }
}
</script>

<style scoped>
/* 
* Global
*/
.MenuSub {
  position: absolute;
  background-color: #FFFFFF;
  box-shadow: 0px 10px 30px 5px rgba(119, 119, 119, 0.1);
  top: 85px;
  right: 0;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  transition-duration: 300ms;
  animation: fadein 300ms;
}

.MenuSub * {
  font-size: 14px !important;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.MenuSub > div {
  flex: 0 0 auto;
}

.Menu-Arrow {
  position: absolute;
  height: 0;
  width: 0;
  top: -15px;
  border-right: 10px solid transparent;
  border-bottom: 16px solid #FFFFFF;
  border-left: 10px solid transparent;
  transition-duration: 1s;
}

/* 
* Links
*/
ul {
  padding: 0;
  list-style-type: none;
}

.MenuSub a {
  display: block;
  text-decoration: none;
  color: black;
  padding: 20px 30px;
  min-width: 300px;
  transition: background-color 300ms, box-shadow 300ms, color 300ms;
}

.MenuSub a:hover {
  color: #00AEB0;
  box-shadow: -2px 0 0 #00AEB0;
}

.MenuSub a.router-link-active {
  box-shadow: -2px 0 0 #00AEB0;
  background-color: rgba(0, 174, 176, 0.05);
  border-radius: 0 6px 6px 0;
}

.MenuSub--divider {
  height: 1px;
  background-color: RGBA(0, 0, 0, 0.03);
  margin: 0 20px;
}

.MenuSub li:last-child .MenuSub--divider {
  display: none;
}

.Position-0 {
  right: 415px;
}

.Position-0 > .Menu-Arrow {
  right: 215px;
}

.Position-1 {
  right: 100px;
}

.Position-1 > .Menu-Arrow {
  right: 298px;
}

.Position-2 {
  right: 0px;
}

.Position-2 > .Menu-Arrow {
  right: 237px;
}

/* 
* Responsive
*/
@media (max-width: 1135px) {
  .MenuSub {
    display: none !important;
  }
}
</style>